import { render, staticRenderFns } from "./RegisterRestaurant.vue?vue&type=template&id=14b9b6f0&"
import script from "./RegisterRestaurant.vue?vue&type=script&lang=js&"
export * from "./RegisterRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./RegisterRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports